import { InputAdornment, TextField } from "@mui/material";
import React from "react";
const TextContainer = (props) => {

    const {style, error, theme} = props;
    const hasValue = Array.isArray(props.value) ? props.value.length > 0 : props.value !== '' && props.value != null && props.value !== undefined;

    const isDark = theme.White !== '#FFFFFF';
    const bgColor = isDark ? theme.Coco : theme.Checo
    return (
        <TextField
            type={props.type || 'text'}
            value={props.value}
            onChange={(e) => props.onChange(e.target.value)}
            onClick={props.onClick}
            onBlur={props.onBlur}
            placeholder={props.placeHolder}
            variant="outlined"
            disabled={props.disabled}
            autoComplete={props.autoComplete}
            style={style}
            multiline={props.multiline || false}
            minRows={props.minRows || 4} //This must have the same value as maxRows to ensure visual correctness
            maxRows={props.maxRows || 4}
            slotProps={{
                input: {
                    startAdornment: props.prefix ? (
                        <InputAdornment position="start">
                            {props.prefix}
                        </InputAdornment>
                    ) : null,
                    endAdornment: props.endIcon ? (
                        <InputAdornment position="end">
                            {props.endIcon}
                        </InputAdornment>
                    ) : props.suffix ? (
                        <InputAdornment position="end">
                            {props.suffix}
                        </InputAdornment>
                    ) : null,
                    readOnly: props.readOnly || false
                }
            }}
            sx={{   
                "& .MuiInputBase-root": { 
                    width: style.width,
                    // minHeight: style.height,
                    borderRadius: '4px',
                    borderWidth: '1px',
                    alignItems: props.multiline ? 'flex-start' : 'center', // Aligns items to the top for multiline
                    // overflow: 'hidden'
                },
                "& .MuiInputAdornment-root": {
                    "& p": {
                        color: isDark ? theme.Black : theme.Audi
                    },
                    "&.Mui-disabled p": {
                        color: isDark ? theme.Black : theme.Audi,
                        opacity: 1
                    }
                },
                "& .MuiOutlinedInput-root": {
                    backgroundColor: bgColor, //Textfield background color
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: error ? theme.Red : (hasValue ? theme.Coco : theme.Ey),
                        borderWidth: error ? '1.5px' : '1px'
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        boxShadow: `
                            0 0 0 1px ${theme.Magenta},
                            0 0 0 2px ${theme.Cyan}
                        `,
                        borderColor: 'transparent', //If changed to a color, it'll renderize in addition to the boxShadow...
                    },
                    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.Ey,
                        opacity: .5,
                    },
                },
                "& .MuiInputBase-input": {
                    color: theme.Black, //Text color
                    paddingTop: props.multiline ? 0 : 1, 
                    paddingBottom: props.multiline ? 0 : 1,
                    overflowY: 'auto',
                    opacity: 1,
                    "&.Mui-disabled": {
                        color: theme.Black,
                        WebkitTextFillColor: theme.Black,
                        opacity: 1
                    }
                },
                "& .MuiInputBase-input::placeholder": {
                    color: theme.Lao, //Placeholder color
                    opacity: 1
                }
            }}
        />
    )
}

export default React.memo(TextContainer);